// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound-module__notFound","disabled":"NotFound-module__disabled"};